import PropTypes from 'prop-types';

export const BatchAdjustmentPropType = PropTypes.shape({
  amountFrom: PropTypes.string.isRequired,
  annualCum: PropTypes.string.isRequired,
  multiplier: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  adjustmentType: PropTypes.string.isRequired,
  companyCode: PropTypes.string.isRequired,
  countryTaxTypeDescription: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  frequency: PropTypes.string.isRequired,
  tagDescription: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});
